import { ActionType } from "../interfaces/api/actionType";

export const GetQuizAnswers: ActionType = {
  FAILURE: "GET_QUIZANSWERS_FAILURE",
  REQUEST: "GET_QUIZANSWERS_REQUEST",
  SUCCESS: "GET_QUIZANSWERS_SUCCESS",
};
